const { contentStyle } = require("../../../../shared/create-offer/Modal/style");

const mySalesLink = `
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 160px;
    padding: 5px;
    border: 1px solid #c8ccd4;
    border-radius: 5px;

    p {
        font-weight: 600;
        margin: 0 0 0 5px;
        color: #1abc9c;
    }

    i {
        font-weight: 600;
        height: 16px !important;
        width: auto !important;
    }

    @media(min-width: 1366px) {
        position: relative;
        border: none;
        width: 20px;
        padding: 0;

        &:hover {
            .as-tooltip {
                display: block !important;
            }
        }

        i {
            width: 20px !important;
            height: 20px !important;
            font-size: 20px;
        }

        .as-tooltip {
            position: absolute;
            top: 100%;
            right: -15px;
            width: 150px;
            padding: 8px 16px;
            font-size: 12px;
            color: #6e798e;
            text-align: center;
            border-radius: 4px;
            box-shadow: 0 8px 20px 0 rgba(34, 50, 84, 0.2);
            background-color: white;

            &:before {
                content: '';
                position: absolute;
                bottom: 100%;
                right: 16px;
                border-left: 8px solid transparent;
                border-right: 8px solid transparent;
                border-bottom: 8px solid white;
            }
        }
    }
`

export default mySalesLink;